import { Application } from '@bonusly/application';
import { joinPath } from '@bonusly/http';

const ANALYTICS_SERVER_URL = 'https://amplitude-events.bonus.ly';
const EXPERIMENT_SERVER_URL = 'https://amplitude-features.bonus.ly';

export const createConfig = (application: Application) => {
	switch (application.env) {
		case 'development':
			return {
				analyticsAPIKey: 'a721d5df5b3e95cfa10fd3db3c327d09',
				experimentAPIKey: 'server-VEKuRGpEwKWnkBpmWTTBAGDKAghsNkGc',
			};

		case 'staging':
			return {
				analyticsAPIKey: 'c3d2dd9da0827cbffc8c0f31faaa5ce1',
				analyticsServerURL: joinPath(ANALYTICS_SERVER_URL, '/2/httpapi'),
				experimentAPIKey: 'server-FERA3FiAEBu3RNbqwwZByBugXp7yfgsW',
				experimentServerURL: EXPERIMENT_SERVER_URL,
			};

		case 'production':
			return {
				analyticsAPIKey: '99f26e5e0720c4ae06798351945d71bf',
				analyticsServerURL: joinPath(ANALYTICS_SERVER_URL, '/2/httpapi'),
				experimentAPIKey: 'server-mfqXX6Fo69f5hz8qlLmFOpm3MlXRFhLJ',
				experimentServerURL: EXPERIMENT_SERVER_URL,
			};

		default:
			return {
				analyticsAPIKey: '',
				experimentAPIKey: '',
			};
	}
};
